import { render, staticRenderFns } from "./ContactsPageDesktop.vue?vue&type=template&id=c8b087ba&scoped=true&"
import script from "./ContactsPageDesktop.vue?vue&type=script&lang=js&"
export * from "./ContactsPageDesktop.vue?vue&type=script&lang=js&"
import style0 from "./ContactsPageDesktop.vue?vue&type=style&index=0&id=c8b087ba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8b087ba",
  null
  
)

export default component.exports